import React from 'react';

const TagAPI = ({ descricaoAPI, api }) => {
    const habilitado = api[descricaoAPI] === '1';

    return habilitado ? (
        <span style={{ backgroundColor: '#00bf9a' }} className={`mx-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full text-green-50`}>
            {descricaoAPI}
        </span>
    ) : null;
};

function TipoAPI({ api }) {
    return (
        <td style={{ backgroundColor: '#27293D' }}>
            <td style={{ backgroundColor: '#27293D' }} nowrap="nowrap" className="text-sm font-medium px-1 text-gray-900">
                <TagAPI descricaoAPI="produtoestoque" api={api} />
                <TagAPI descricaoAPI="vendaCliente" api={api} />
                <TagAPI descricaoAPI="farmaciasAPP" api={api} />
                <TagAPI descricaoAPI="financeiro" api={api} />
                <TagAPI descricaoAPI="notas" api={api} />
                <TagAPI descricaoAPI="preVenda" api={api} />
                <TagAPI descricaoAPI="precificacaoDiferenciada" api={api} />
            </td>
        </td>
    );
}

export default TipoAPI;
